const WM_LAYER_CLASS = "page-watermark-layer";

const createWatermark = (
  text: string,
  domClassName: string,
  bgColor = ""
) => {
  if (!text || text === "null") {
    return false;
  }
  const domList = document.querySelectorAll(`.${domClassName}`);
  Array.from(domList).forEach((dom) => {
    const el = dom as HTMLElement;
    const canvas = document.createElement("canvas");
    canvas.width = 120;
    canvas.height = 80;
    const context = canvas.getContext("2d");
    if (!context) return;
    context.rotate((-30 * Math.PI) / 180);
    context.font = "15px microsoft yahei";
    context.fillStyle = "rgba(0,0,0,0.06)";
    context.fillText(text, 0, 45, canvas.height);
    const curl = canvas.toDataURL("image/png");

    el.style.backgroundColor = bgColor || "";

    let layer = el.querySelector(`.${WM_LAYER_CLASS}`) as HTMLElement | null;
    if (!layer) {
      layer = document.createElement("div");
      layer.className = WM_LAYER_CLASS;
      if (getComputedStyle(el).position === "static") {
        el.style.position = "relative";
      }
      el.appendChild(layer);
    } else if (el.lastChild !== layer) {
      el.appendChild(layer);
    }
    layer.style.cssText = [
      "position:absolute",
      "left:0",
      "top:0",
      "right:0",
      "bottom:0",
      "pointer-events:none",
      "z-index:999",
      "background-color:transparent",
      `background-image:url(${curl})`,
      "background-position:left top",
      "background-repeat:repeat",
    ].join(";");
  });
};

export default createWatermark;
